import React from 'react'
import { CarePlan as FHIRCarePlan } from '@teschglobal/tg-fhir-react-components/dist/types'
import FhirLoader from '../../../../FhirLoader'
import useFhirConfig from '../../../../../hooks/admin/useFhirConfig'
import { CarePlan } from '@teschglobal/tg-fhir-react-components'
import { UseQueryResult } from 'react-query'
import useFhirResourceById from '../../../../../hooks/admin/useFhirResourceById'
import { CarePlanDisplayType } from '../../../../../types/CarePlanDisplayType'

type CarePlanDetailProps = {
  carePlanDetailId: string
  displayType: CarePlanDisplayType
}

const CarePlanDetail: React.FC<CarePlanDetailProps> = ({ carePlanDetailId, displayType }) => {
  const { patientAccessFhirConfig } = useFhirConfig()

  const {
    data: carePlan,
    isFetching,
    isLoading,
    isError
  }: UseQueryResult<FHIRCarePlan, Error> =
    useFhirResourceById('Patient Access', carePlanDetailId || '', 'CarePlan')

  if (isFetching || isLoading) {
    return <FhirLoader />
  }

  if (!carePlan || isError) {
    return <div className='text-center' role='status' aria-live='polite' aria-atomic='true'>Not Found</div>
  }

  return (
    <div>
      <section>
        <CarePlan
          data={carePlan}
          fhirApiConfig={patientAccessFhirConfig}
          displayMode={displayType}
        />
      </section>
    </div>
  )
}

export default CarePlanDetail